<template>
  <div class="animated fadeIn">
  
    <b-row style="margin-bottom:20px;">
      <b-col lg="12" class="col-toggle">
        <span> {{ $t('menu.show_card') }} </span> 
        <c-switch class="mx-1" color="primary" v-model="showTable"  :checked="showTable" variant="pill" />
        <span> {{ $t('menu.show_table') }} </span> 
      </b-col>
    </b-row>

  
    <!-- <b-row style="margin-bottom:20px;">
      <b-col lg="12" class="col-toggle">
        <h3>{{ $t('menu.generated_menu') }}</h3>
      </b-col>
    </b-row>

          
    <b-row v-if="!showTable">
      <b-col sm="6" lg="3"  v-for="menu in items">
        <b-card>
          <div class="h4 m-0"> 
             <router-link :to="{ name: 'SingleMenu', params: { id: menu.id }}" v-b-tooltip.hover title="Click For Details">menu {{ menu.id}}</router-link>
          </div>
          <div>{{ $t('menu.client') }} : {{ menu.client }} </div>
          <div>{{ $t('menu.meals') }} : {{ menu.meals.length }} </div>
          <div>{{ $t('menu.created_at') }} : {{ menu.created_at}}  </div>
          <div>{{ $t('menu.nutritionist') }} : {{ menu.nutritionist}} </div>
          <div>{{ $t('menu.source') }} : {{ menu.source}} </div>
        </b-card>
      </b-col>
    </b-row> -->
          
  
    <b-row style="margin-bottom:20px;">
      <b-col lg="12" class="col-toggle">
        <h3>{{ $t('menu.manual_created') }}</h3>
      </b-col>
    </b-row>

    <b-row v-if="!showTable">
      <b-col sm="6" lg="3"  v-for="menu in createdmenus">
        <b-card>
          <div class="h4 m-0"> 
             <router-link :to="{ name: 'SingleCreatedMenu', params: { id: menu.id }}" v-b-tooltip.hover title="Click For Details">menu {{ menu.id}}</router-link>
            <b-button aria-label="Close" class="close remove-button" @click="removeMenu(menu.id)">x</b-button>
            <router-link class="close" :to="{ name: 'Update Menu', params: { id: menu.id }}" v-b-tooltip.hover title="Click For Details"> <i class="fa fa-edit icon"></i> </router-link>
          </div>
          <div>{{ $t('menu.client') }} : {{ menu.client.first_name }} {{ menu.client.last_name }}</div>
          <div>{{ $t('menu.meals') }} : <span v-for="meal in menu.meals">{{meal.type}}, </span> </div>
          <div>{{ $t('menu.nutritionist') }} : {{ user.first_name }} {{ user.last_name }}</div>
          <div>{{ $t('menu.day') }} : {{ menu.day}} </div>
          <div>{{ $t('menu.created_at') }} : {{ menu.created_at}}  </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- <b-row v-if="showTable">
      <b-col lg="12">
        <b-table @click="clicked($event)" responsive="md" :items="items" :fields="fields"></b-table>
      </b-col>
    </b-row> -->
    <b-row v-if="showTable">
      <b-col lg="12">
        <table class="table">
          <thead>
            <th>{{ $t('menu.menu_id') }}</th>  
            <th>{{ $t('menu.client') }}</th>  
            <th>{{ $t('menu.meals') }}</th>  
            <th>{{ $t('menu.nutritionist') }}</th>  
            <th>{{ $t('menu.day') }}</th>  
            <th>{{ $t('menu.created_at') }}</th>  
          </thead>
          <tbody>
            <tr v-for="menu in createdmenus">
              <td> <router-link :to="{ name: 'SingleCreatedMenu', params: { id: menu.id }}" v-b-tooltip.hover title="Click For Details">menu #{{ menu.id}}</router-link></td>
              <td> {{ menu.client.first_name }} {{ menu.client.last_name }}</td>
              <td> <span v-for="meal in menu.meals">{{meal.type}}, </span></td>
              <td> {{ user.first_name }} {{ user.last_name }}</td>
              <td> {{ menu.day}}</td>
              <td> {{ menu.created_at}}</td>
            </tr>
          </tbody>
        </table>
        <!-- <b-table responsive="md" :items="createdmenus" :fields="createdfields"></b-table> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>


import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Models from '@/store/ORM/models.js';
import { Switch as cSwitch } from '@coreui/vue';
import MenuService from '@/services/menu.service.js';
import DataMenuService from '@/services/datamenu.service.js';

export default {
  name: 'dashboard',
  components: {
    cSwitch
  },
  data: function () {
    return {
      showTable : false,
      items: [],
      createdmenus: [],
      fields: [
         { key:"id"},
         { key:"client"},
        //  { key:"meals"},
        //  { key:"nutritionist"},
         { key:"problems"},
         { key:"source"},
         { key:"stats"},
         { key:"created_at"},
      ],
      createdfields: [
         { key:"id"},
         { key:"client_id"},
        //  { key:"foods"},
         { key:"type"},
         { key:"created_at"},
      ],
      user : Models.Nutritionist.query().first()
    }
  },
  methods: {
    refresh() {
      MenuService.getMenus(this.user.id)
        .then(result => {
          Models.Menu.deleteAll();
          Models.Menu.create({ data: result.data.results });
          this.items = Models.Menu.query().with('client').with('nutritionist').with('meals').get();
          console.log(this.items);
        })
        .catch(error => {
          alert(error)
        })
    },
    clicked(event){
      console.log(event);
    },
    removeMenu(id){
      var i18n = this.$i18n;
      this.$swal({
        title: this.$i18n.t('menu.delete'),
        icon: "warning",
        buttons: {
          cancel: this.$i18n.t('menu.no'),
          ok: {
            text: this.$i18n.t('menu.yes'),
            value: "yes",
          }
        },
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          DataMenuService.deleteMenu(id).then((res)=>{
            if(res.data.success){
              Models.CreatedMenu.delete(id);
              let menus = Models.CreatedMenu.query().with('nutricionist_id').with('meals').all();
              menus.map((menu)=>{
                menu.client = Models.Client.where('id',menu.client_id).first()
              });
              this.createdmenus = menus;


              swal( i18n.t('menu.deleted_success'), {
                icon: "success",
              });
            }
          })
        }
      });
    }
  },
  created(){
    this.items  = Models.Menu.query().with('client').with('nutritionist').with('meals').all();
    let menus = Models.CreatedMenu.query().with('nutricionist_id').with('meals').all();
    menus.map((menu)=>{
      menu.client = Models.Client.query().where('id',menu.client_id).first()
    });
    this.createdmenus = menus;
  },
  computed: {
    getUser : function() {
      return this.$store.state['UserModules'].user;
    }
  },
}
</script>

<style>
 .col-toggle{
   display:flex;
   align-items:center;
 }
 .close:hover{
   background:transparent;
 }
 .icon{
  font-size: 14px;
  margin-right: 10px;
 }

 .remove-button{
    float: right;
    color: red;
    font-weight: 700;
 }
</style>
